<template>
  <div :class="['fc-event-main-frame', 'task-resource-event', {'task-status-cancelled': isTaskStatusCancelled}]">
    <div class="fc-event-title-container">
      <div class="float-right">
        <ActionDropMenu class="float-right task-resource-event-actionmenu" :tableAction="true" :forceDropdown="true">
          <DropdownMenuItem icon="fa-print" @click="$emit('printRunSheet')" v-if="!isTaskStatusCancelled && !isTaskStatusCompleted">Display Runsheet</DropdownMenuItem>
        </ActionDropMenu>
      </div>
      <div class="fc-event-title fc-sticky">
        <Icon :iconStyle="taskStatusIconStyle(task.status)" :icon="taskStatusIcon(task.status)"  />
        {{title}}
      </div>
      <div class="fc-event-time">
        <i class="fal fa-clock fa-fw"></i> {{timeText}}
      </div>
      <div class="task-resource-event-description" v-if="task.sequenceNumber">
        <i class="fal fa-info-circle fa-fw"></i> {{task.sequenceNumber}}
      </div>
      <div class="task-resource-event-description" v-if="task.description">
        <i class="fal fa-sticky-note fa-fw"></i> {{task.description}}
      </div>
      <div v-if="task.taskItems && task.taskItems.length > 0">
        <div class="ml-2 my-1">

          <div v-if="pendingItemList.length > 0">
            <Icon
              :iconStyle="taskStatusIconStyle(pendingItemList[0].status)"
              :icon="taskStatusIcon(pendingItemList[0].status)"
              class="mr-1" /> {{pendingItemList.length}} task item{{pendingItemList.length | displayCountPlural}} waiting
          </div>

          <div v-if="activeItemList.length > 0">
            <Icon
              :iconStyle="taskStatusIconStyle(activeItemList[0].status)"
              :icon="taskStatusIcon(activeItemList[0].status)"
              class="mr-1" /> {{activeItemList.length}} task item{{activeItemList.length | displayCountPlural}} in progress
          </div>

          <div v-if="completedItemList.length > 0">
            <Icon
              :iconStyle="taskStatusIconStyle(completedItemList[0].status)"
              :icon="taskStatusIcon(completedItemList[0].status)"
              class="mr-1" /> {{completedItemList.length}} task item{{completedItemList.length | displayCountPlural}} completed
          </div>

          <div v-if="cancelledItemList.length > 0">
            <Icon
              :iconStyle="taskStatusIconStyle(cancelledItemList[0].status)"
              :icon="taskStatusIcon(cancelledItemList[0].status)"
              class="mr-1" /> {{cancelledItemList.length}} task item{{cancelledItemList.length | displayCountPlural}} cancelled
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TaskManagerMixin from '@/modules/tasks/mixins/taskManagerMixin'
import { TaskStatusTypes, TaskItemStatusTypes } from '@/store/types'

export default {
  name: 'CalendarResourceTaskView',
  mixins: [TaskManagerMixin],
  props: {
    title: String,
    timeText: String,
    task: Object
  },
  computed: {
    pendingItemList() {
      if(!this.task || !this.task.taskItems)
        return []
      return this.task.taskItems.filter(taskItem => taskItem.status == TaskItemStatusTypes.pending)
    },
    activeItemList() {
      if(!this.task || !this.task.taskItems)
        return []
      return this.task.taskItems.filter(taskItem => taskItem.status == TaskItemStatusTypes.active)
    },
    completedItemList() {
      if(!this.task || !this.task.taskItems)
        return []
      return this.task.taskItems.filter(taskItem => taskItem.status == TaskItemStatusTypes.completed)
    },
    cancelledItemList() {
      if(!this.task || !this.task.taskItems)
        return []
      return this.task.taskItems.filter(taskItem => taskItem.status == TaskItemStatusTypes.cancelled)
    },
    isTaskStatusCancelled() {
      if(!this.task)
        return false
      return this.task.status == TaskStatusTypes.cancelled
    },
    isTaskStatusCompleted() {
      if(!this.task)
        return false
      return this.task.status == TaskStatusTypes.completed
    }
  },
  created() {
    this.TaskStatusTypes = TaskStatusTypes
  }
}
</script>